<template>
  <TirPmPopover
    class="task-time-tracker-confirm-popover"
    ref="$popover"
    :custom-position="customPosition"
    width="19.625rem"
  >
    <div class="task-time-tracker-confirm-popover__target" @click.stop />
    <template #content>
      <div class="task-time-tracker-confirm-popover__content">
        <span class="task-time-tracker-confirm-popover__title">Запустить новый таймер?</span>
        <div class="task-time-tracker-confirm-popover__description">
          <p class="task-time-tracker-confirm-popover__description-part">
            У вас уже запущен таймер на другом тикете.
          </p>
          <p class="task-time-tracker-confirm-popover__description-part">
            Если запустите новый, старый таймер будет остановлен
          </p>
        </div>
        <div class="task-time-tracker-confirm-popover__buttons">
          <TirPmButton
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.PrimaryState"
            :is-loading="isLoading"
            @click="emit('confirm')"
          >
            Запустить новый таймер
          </TirPmButton>
          <TirPmButton
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.SecondaryState"
            @click="$popover?.close"
          >
            Отмена
          </TirPmButton>
        </div>
      </div>
    </template>
  </TirPmPopover>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import {
  TirPmPopover,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-components";

const emit = defineEmits<{
  /**Событие подтверждения */
  (e: "confirm"): void;
}>();

const props = defineProps({
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
});

/**Ссылка на компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

const customPosition = computed(() => {
  return {
    right: "0.75rem",
    bottom: "3.75rem",
  };
});

defineExpose({
  open: () => $popover.value?.open(),
});
</script>

<style lang="scss" scoped>
.task-time-tracker-confirm-popover {
  &__content {
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &__title {
    color: var(--text-primary, #272d37);
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
  }
  &__description {
    color: var(--text-secondary, #686c73);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
  }
  &__description-part {
    margin: 0;
    padding: 0;
  }
  &__buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}
</style>
